<template>
<div class="category-main-te">
    <!-- <div class="item"><img src="https://www.kriyana.com/category_images/category6.png" class="CatgImage"><br><span>All</span></div> -->
    
    <div class="item " v-for="item in CategoryList" :key="item.category" :class="getClass(item.category,selecetdCategory)" :loading="loading" @click="selecetdCatg(item.category)">
        <img class="CatgImage" :src="getImage(item.category_image)" />
        <br><span>{{item.category}}</span>
    </div>
</div>
</template>

<script>
import axios from "axios"
import ApiList from './ApiList'

export default {
    props:['parentCategory'],
    mixins:[ApiList],
    data() {
        return {
            loading: false,
            ImageUrl: "https://www.kriyana.com/category_images/",
            apiUrl: "https://www.kriyana.com/kriyanamobile_api_jwt",
            CategoryList: [],
            selecetdCategory: 'All',
        }
    },
    mounted() {
        this.loadCategories()
    },
    methods: {
        loadCategories() {
            // alert(this.selecetdCategory)
            axios.get(this.apis.apiUrl + "/Product/listCategories?token="+localStorage.token)
                .then((response) => {
                    // console.log(response)
                    this.CategoryList = response.data
this.CategoryList[0]= {"category":"All","category_image":"category6.png","counting":"0","lifespan":"NA","gst":"0","threshhold":"NA"}
                    
                })
        },
        reserve() {
            this.loading = true
            setTimeout(() => (this.loading = false), 2000)
        },
        selecetdCatg(categoryName) {
            this.selecetdCategory = categoryName
            this.$emit('selecetdCategory', categoryName)
        },
        getClass(text1, text2) {
            if (text1 === text2)
                return "card_active"
            else
                return "card_deactive"
        },
        getImage(img) {
            // console.log("images -  " + this.ImageUrl + img)
            return this.ImageUrl + img;
        }
    },
    watch: {
        selecetdCategory: function () {
            this.loadCategories()
        },
        parentCategory : function(){
          //  alert("parent - "+this.parentCategory)
            this.selecetdCategory = this.parentCategory
        // this.loadCategories()
        },

    },

}
</script>

<style>
.category-main-te {
    overflow-x: auto;
    white-space: nowrap;
    padding: 3px 0;
}

.item {
    padding: 5px;
    margin: 2px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    display: inline-block;
}

.CatgImage {
    width: 50px;
}

.card_active {
    border-radius: 3px;
        box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)!important;
}

.card_deactive {
    border: 0px solid transparent !important;
}
</style>
